const initDesktopNav = () => {
  const checkDesktopNav = () =>{
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const menu_overlay_block = document.querySelector('#overlay-mega-menu');
    if (windowWidth > 1200) {
      const menuItems = document.querySelectorAll('#menu-hauptmenue > .menu-item-has-children');
      menuItems.forEach(function(menuItem) {
        menuItem.addEventListener('mouseenter', function(e) {
          if (window.innerWidth > 1199.99) {
            document.body.classList.remove('mega-menu-open');
            console.log('enter');
            document.body.classList.add('mega-menu-open');
            menuItem.classList.add('menu-in-hover');
            console.log(e.target.querySelector('.dropdown-menu').offsetHeight);
            //menu_overlay_block.style.transition = 'height 0.3s ease';

            menu_overlay_block.style.height = (e.target.querySelector('.dropdown-menu').offsetHeight + 150) + 'px';
          }
        });
        menuItem.addEventListener('mouseleave', function() {
          if (window.innerWidth > 1199.99) {
            console.log('leave');
            document.body.classList.remove('mega-menu-open');
            menuItem.classList.remove('menu-in-hover');
            //console.log('leave');
          }
        });
      });
    }
  }
  window.addEventListener('resize', checkDesktopNav);
  window.addEventListener('load', checkDesktopNav);
};
export default initDesktopNav;
